/*
 * Copyright (c) 2023 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, April 20th 2023, 11:36:18 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { intersection } from "lodash";
import { TResourcePolicy, TSubject, TCondition } from "authorization/abac/types";
import { SubscriptionPlan } from "saas-subscription/schemas";

interface FeaturePolicyAttributes {
  subscriptionCodes: SubscriptionPlan["metadata"]["product_code"][];
}

type TFeaturePolicy = TResourcePolicy<FeaturePolicyAttributes>;

class FeaturePolicy implements TFeaturePolicy {
  public type: TFeaturePolicy["type"] = "feature";

  _checkProductCode(conditions: TCondition<FeaturePolicyAttributes>, subject: TSubject<FeaturePolicyAttributes>) {
    return intersection(conditions.subscriptionCodes, subject.subscriptionCodes).length > 0;
  }

  checkPolicy(conditions: FeaturePolicyAttributes, subject: TSubject<FeaturePolicyAttributes>) {
    switch (subject.type) {
      case "organization":
        return this._checkProductCode(conditions, subject);
      default:
        return false;
    }
  }
}

export const featurePolicy = new FeaturePolicy();
